import { Popover, PopoverProps } from "antd"
import Calendars, { CalendarsProps } from "./Calendars"
import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import {
  closeAllFlightSearchOverlays,
  registerFlightSearchOverlayCloser,
} from "@/components/flight/FormSearch/flightSearchOverlays"

type TEDatePickerProps = CalendarsProps & {
  popupProps?: PopoverProps,
  children: any,
  onClose?: () => void
}

export type TEDatePickerRef = {
  close: () => void,
  open: () => void
}

const TEDatePicker = forwardRef<TEDatePickerRef, TEDatePickerProps>(({ children, popupProps, onClose, ...props }, ref) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    return registerFlightSearchOverlayCloser(() => setOpen(false))
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: () => {
        closeAllFlightSearchOverlays()
        setOpen(true)
      },
      close: () => setOpen(false),
    }
  }, [])

  return (
    <Popover
      open={open}
      onOpenChange={(p) => {
        if (p) {
          closeAllFlightSearchOverlays()
          setOpen(true)
        } else {
          setOpen(false)
        }
      }}
      trigger={['click']}
      arrow={false}
      {...popupProps}
      content={(
        <Calendars
          {...props}
          close={() => {
            setOpen(false)
            if (!!onClose) {
              onClose()
            }
          }}
        />
      )}
    >
      {children}
    </Popover>
  )
})

export default TEDatePicker
